import React from 'react';

export const Plus = ({ width = 16, height = 16, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.0013 2.66016C8.36949 2.66016 8.66797 2.95863 8.66797 3.32682V12.6602C8.66797 13.0283 8.36949 13.3268 8.0013 13.3268C7.63311 13.3268 7.33464 13.0283 7.33464 12.6602V3.32682C7.33464 2.95863 7.63311 2.66016 8.0013 2.66016Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.66797 7.99848C2.66797 7.63029 2.96645 7.33181 3.33464 7.33181H12.668C13.0362 7.33181 13.3346 7.63029 13.3346 7.99848C13.3346 8.36667 13.0362 8.66515 12.668 8.66515H3.33464C2.96645 8.66515 2.66797 8.36667 2.66797 7.99848Z"
      fill="currentColor"
    />
  </svg>
);
